import React from 'react'

import { BrowserRouter, Switch, Route, useLocation } from 'react-router-dom'

import Terms from 'pages/terms'
import PrivacyPolicy from 'pages/privacyPolicy'
import FieldNotebooks from 'pages/fieldNotebooks'

const Routes = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path='/v5/terms' component={Terms} />
        <Route exact path='/v5/privacy_policies' component={PrivacyPolicy} />
        <Route exact path='/v5/field_notebooks' component={FieldNotebooks} />
      </Switch>
    </BrowserRouter>
  )
}

export default Routes
